import React from 'react';
import load from '../hocs/load';
import config from '../config';
var ProductPositionDetailsContainer = load(function () {
  return import('../components/ProductPositionDetails/ProductPositionDetailsContainer');
});
var OrderHistoryComponent = load(function () {
  return import('../components/OrderHistoryComponents');
});
var FixedLeftFluidLayout = load(function () {
  return import('../layouts/FixedLeftFluidLayout/FixedLeftFluidLayout');
});
var TradingLayout = load(function () {
  return import('../layouts/TradingLayout/TradingLayoutContainer');
});
var BalancesMenuContainer = load(function () {
  return import('../components/BalancesMenu/BalanceMenuContainer');
});

// this.context.t('Trading')
// this.context.t('Balances')
// this.context.t('User Settings')
export var mainNavOptions = {
  mainNavItems: [{
    text: 'Trading',
    icon: 'trading',
    path: '/trading'
  }, {
    text: 'Balances',
    icon: 'balance',
    path: '/balances'
  }, {
    text: 'User Settings',
    icon: 'user-settings',
    path: '/settings/profile'
  }],
  settingsPath: '/settings/profile'
};
export var routesArray = [{
  path: '/trading',
  render: function render() {
    return React.createElement(TradingLayout, null);
  }
}, {
  path: '/balances',
  render: function render() {
    return React.createElement(FixedLeftFluidLayout, {
      left: [React.createElement(BalancesMenuContainer, {
        key: '2'
      })]
    }, React.createElement(ProductPositionDetailsContainer, null), React.createElement(OrderHistoryComponent, {
      classModifiers: ['full-height'],
      useHeaderWithFilter: true,
      config: {
        maxLines: config.BalancesLayout.maxLines,
        filterMode: 'selectedProduct',
        usePagination: false
      }
    }));
  }
}];